import { render, staticRenderFns } from "./HeadingBlue.vue?vue&type=template&id=429a1352&scoped=true"
import script from "./HeadingBlue.vue?vue&type=script&lang=ts"
export * from "./HeadingBlue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429a1352",
  null
  
)

export default component.exports